import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';
import { PageProps, PageToolEvents } from '../../../../constants';
import { RegionTemplate } from './Region.template';
import { RegionModel } from './Region.model';
import { TableLayout } from '../../../../components/layout/TableLayout';
import { InfinityRetrieve } from '../../../../models/common';
import { ConfirmWarning } from '../../../../utils/confirm';
import { PageComponent } from '../../../../utils';


interface RegionState {
  searchQuery: string;
  data: Array<RegionModel>;
  gareacds?: Array<any>;
  focused?: RegionModel;
}

/**
 * 컨트롤러
 * @window w_tb_e028
 * @category 지역등록
 */
@inject('routerStore', 'publicStore', 'modalStore', 'actionStore')
@observer
export class Region extends PageComponent<PageProps, RegionState>
  implements PageToolEvents {
  storedData?: RegionState;

  updatedRows?: Array< RegionModel>;

  table: React.RefObject<TableLayout> = React.createRef();

  infinity?: InfinityRetrieve;

  constructor(props: PageProps, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    // state 기본값 정의
    this.state = props.state || {
      searchQuery: '',
      data: [],
    };
  }

  @action
  async onFirstOpenEvent() {
    const { actionStore: api } = this.props;
    const data = await api.dropdown('wf_dd_e027');
    // 서버 요청
    // 검사담당부서 리스트 가져오기
    // 실패시 리턴
    if (!data) return;

    // 성공시 상태 반영
    this.setState({ gareacds: data.items });

    // 선행되어야 하는 서버 호출이 모두 성공한 경우 [조회]
    this.onRetrieveEvent();
  }


  @action
  async onRetrieveEvent() {
    const { actionStore: api } = this.props;
    const data = await api.retrieve();

    this.SS({
      data: data?.items?.map((x: any) => new RegionModel(x)) || [],
    });

    await this.table.current?.update();
    await this.table.current?.setFocus(0, 1);
  }

  @action
  async onNewEvent() {
    const { actionStore: api } = this.props;
    const data = await api.new();

    data && this.setState({
      data: [
        new RegionModel(data, true),
        ...this.state.data,
      ],
    }, async () => {
      await this.table.current?.update(false);
      this.table.current?.setFocus(0, 1);
    });
  }

  @action
  async onSaveEvent() {
    const { actionStore: api } = this.props;
    if (await api.save({
      items: this.updatedRows,
    }, true)) {
      this.updatedRows = [];
      this.table.current?.resetUpdates();
    }
  }

  @action
  async onDeleteEvent() {
    const { actionStore: api } = this.props;
    const text = `${this.state.focused?.areacd} - ${this.state.focused?.areanm}`;
    await api.delete(text, this.state.focused) && await this.onRetrieveEvent();
  }

  @action
  async onPrintEvent() {
    const { actionStore: api } = this.props;
    if (!ConfirmWarning.assert(this.state.data?.length, '오류', '출력할 내역이 없습니다.')) {
      return;
    }
    await api.printWithElmanManager();
  }

  @action
  async onExcelEvent() {
    const { actionStore: api } = this.props;
    if (!ConfirmWarning.assert(this.state.data?.length, '오류', '엑셀변환할 내역이 없습니다.')) {
      return;
    }
    await api.excel();
  }

  @action
  onRowFocusEvent(item: RegionModel) {
    this.setState({ focused: item });
  }

  /**
   * 행 변경 이벤트
   * @param rows        전체 행 (변경 행 반영된 상태)
   * @param updatedRows 변경 행들만
   */
  @action
  onUpdatedRows(rows: Array<RegionModel>, updatedRows: Array<RegionModel>) {
    this.updatedRows = updatedRows;
    this.setState({ data: rows });
  }

  render() {
    return (
      < RegionTemplate
        scope={this}
      />
    );
  }
}
